<template>
    <div>
        <div v-if="use_cache || !$store.state.is_online">
            <h3 class="mt-2 mb-3" v-if="issue_type == 'highway'">Offline Corrective Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'electrical_maintenance'">Offline Electrical Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'major_maintenance'">Offline Major Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'routine_maintenance'">Offline Routine Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'road_user_accident'">Offline Road User Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'occupational'">Offline Occupational Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'hazard'">Offline Hazard Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'dead_animal_debris_removal'">Offline Dead Animal Debris Removal Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'vehicle_breakdown'">Offline Vehicle Breakdown Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'traffic_violation'">Offline Traffic Violation Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_parking'">Offline Unauthorised Parking Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_access'">Offline Unauthorised Access Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_media_cut'">Offline Unauthorised Median Cut Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'material_damage'">Offline Material Damage Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'other'">Offline Other Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'enroachment_row'">Offline Enroachment Row Issue</h3>
        </div>
        <div v-else>
            <h3 class="mt-2 mb-3" v-if="issue_type == 'highway'">Corrective Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'major_maintenance'">Major Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'road_user_accident'">Road User Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'occupational'">Occupational Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'hazard'">Hazard Accident Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'dead_animal_debris_removal'">Dead Animal Debris Removal Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'vehicle_breakdown'">Vehicle Breakdown Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'traffic_violation'">Traffic Violation Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_parking'">Unauthorised Parking Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_access'">Unauthorised Access Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_media_cut'">Unauthorised Median Cut Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'material_damage'">Material Damage Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'other'">Other Issue</h3>
            <h3 class="mt-2 mb-3" v-else-if="issue_type == 'enroachment_row'">Enroachment Row Issue</h3>
        </div>

        <!-- checking permissions  -->
        <div v-if="hasPermission">
            <div v-if="issue.id" class="mb-3">
                <router-link :to="{name: 'issues-resolution', params: {issue_type: issue_type, issue_id: issue.id}}">
                    <vs-button type="filled" size="small" color="primary">View Resolution</vs-button>
                </router-link>
            </div>
    
            <vs-row class="mt-base mb-3" v-if="mode == 'v' && issue.status == 'a' && !use_cache">
                <vs-col>
                    <span class="text-success font-bold">Approved By: </span> {{ issue.reviewed_by.first_name || '' }} {{ issue.reviewed_by.last_name || '' }} <br/>
                    <span class="text-success font-bold">Assigned to:</span>
                    <template v-if="issue.resource_allocation == 'e'">
                        {{ issue.allocated_resource.first_name }} {{ issue.allocated_resource.last_name }} (Vendor),
                    </template>
                    {{ issue.allocated_engineer.first_name }} {{ issue.allocated_engineer.last_name }} (Employee)
                </vs-col>
            </vs-row>
    
            <vs-row class="mt-base mb-3" v-if="issue.status == 'r' && !use_cache">
                <vs-col>
                    <span class="text-danger font-bold">Rejected By: </span> {{ issue.reviewed_by.first_name || '' }} {{ issue.reviewed_by.last_name || '' }} <br/>
                    <span class="text-black font-bold">Comment: </span>{{ issue.comments || "No Comment" }}
                </vs-col>
            </vs-row>

            <vx-card noShadow noRound>
                <HighwayEdit v-if="issue_type == 'highway'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons" 
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <OccupationalEdit v-else-if="issue_type == 'occupational'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <HazardEdit v-else-if="issue_type == 'hazard'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <RoadUserAccidentEdit v-else-if="issue_type == 'road_user_accident'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <TrafficViloationEdit v-else-if="issue_type == 'traffic_violation'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <UnauthorisedAccessEdit v-else-if="issue_type == 'unauthorised_access'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <UnauthorisedMedianCutEdit v-else-if="issue_type == 'unauthorised_media_cut'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <UnauthorisedParkingEdit v-else-if="issue_type == 'unauthorised_parking'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <VehicleBreakdownEdit v-else-if="issue_type == 'vehicle_breakdown'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <MaterialDamageEdit v-else-if="issue_type == 'material_damage'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <EnroachmentRowEdit v-else-if="issue_type == 'enroachment_row'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <DeadAnimalDebrisRemovalEdit v-else-if="issue_type == 'dead_animal_debris_removal'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <OtherEdit v-else-if="issue_type == 'other'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <ElectricalMaintenanceEdit v-else-if="issue_type == 'electrical_maintenance'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <MajorMaintenanceEdit v-else-if="issue_type == 'major_maintenance'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
                <RoutineMaintenanceEdit v-else-if="issue_type == 'routine_maintenance'" :mode="mode" :issue.sync="issue" :api_errors="api_errors" :show_action_buttons="show_action_buttons"
                    :show_review="showReview" @approve="approve" @reject="reject" :manager_dropdown="manager_dropdown"
                />
    
                <vs-row class="mt-base" v-if="mode == 'e'">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
            <RejectionPopup :is_active.sync="reject_popup.active" :api_errors="reject_popup.api_errors" :submit="do_reject" />
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";
import HighwayEdit from "./Highway/HighwayEdit.vue";
import OccupationalEdit from "./Occupational/OccupationalEdit.vue";
import HazardEdit from "./Hazard/HazardEdit.vue";
import RoadUserAccidentEdit from "./RoadUserAccident/RoadUserAccidentEdit.vue";
import TrafficViloationEdit from "./TrafficViolation/TrafficViloationEdit.vue";
import UnauthorisedAccessEdit from "./UnauthorisedAccess/UnauthorisedAccessEdit.vue";
import UnauthorisedMedianCutEdit from "./UnauthorisedMedianCut/UnauthorisedMedianCutEdit.vue";
import UnauthorisedParkingEdit from "./UnauthorisedParking/UnauthorisedParkingEdit.vue";
import VehicleBreakdownEdit from "./VehicleBreakDown/VehicleBreakdownEdit.vue";
import MaterialDamageEdit from "./MaterialDamage/MaterialDamageEdit.vue";
import EnroachmentRowEdit from "./EnroachmentRow/EnroachmentRowEdit.vue";
import DeadAnimalDebrisRemovalEdit from "./DeadAnimalDebrisRemoval/DeadAnimalDebrisRemovalEdit.vue";
import OtherEdit from "./Other/OtherEdit.vue";
import ElectricalMaintenanceEdit from "./ElectricalMaintenance/ElectricalMaintenanceEdit.vue";
import MajorMaintenanceEdit from "./MajorMaintenance/MajorMaintenanceEdit.vue";
import RoutineMaintenanceEdit from "./RoutineMaintenance/RoutineMaintenanceEdit.vue";

import RejectionPopup from "./Components/RejectionPopup.vue";

export default {
    props: {
        mode: {
            required: true,
            type: String
        },
        use_cache: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            issue_id: this.$route.params.issue_id,
            issue_type: this.$route.params.issue_type,

            issue: {
                id: null,
                reported_by: this.$store.state.organisation.organisation_user,
                assigned_reviewers: [],
                created_on: new Date().toISOString(),
                images: []
            },

            submit_disabled: false,
            api_errors: {},
            reject_popup: {
                active: false,
                api_errors: {}
            }
        }
    },
    computed: {
        show_action_buttons () {
            if (this.mode != 'v') return false

            if (this.issue.status != 'p') return false
            
            return true
        },
        viewIssue() {
            let user_ids = this.issue.assigned_reviewers.map(v=>v.id)
            user_ids.push(this.issue.reported_by.id)
            return this.hasAccess('read', `issue_${this.issue_type}`, 'any', user_ids)
        },
        createIssue() { 
            return this.hasAccess('create', `issue_${this.issue_type}`, 'all') 
        },
        editIssue() { 
            return this.hasAccess('edit', `issue_${this.issue_type}`, ['all', 'own'], [this.issue.reported_by.id]) 
        },
        showReview() { 
            return this.hasAccess('review', `issue_${this.issue_type}`, ['all', 'assigned'], this.issue.assigned_reviewers.map(v=>v.id)) 
        },
        hasPermission() {
            return (!this.issue.id && this.createIssue) || (this.issue.id && this.mode=='e' && this.editIssue) || (this.issue.id && this.mode=='v' && this.viewIssue)
        }
    },
    watch: {
        "$route.params.issue_type"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        },
        "$route.params.issue_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.issue_type = this.$route.params.issue_type
            this.issue_id = this.$route.params.issue_id

            if (this.issue_id) this.load_data()
            else {
                this.issue = {
                    id: null,
                    reported_by: this.$store.state.organisation.organisation_user,
                    assigned_reviewers: [],
                    created_on: new Date().toISOString(),
                    images: []
                }
            }
        },
        async load_data() {

            if (this.use_cache) {
                let res = await this.$ionicStorage.get(`issues__${this.issue_type}`)
                if (res) {
                    res = JSON.parse(res)
                    let data = res.filter(obj => obj.id == this.issue_id)[0]
                    // putting id into secondary model data 
                    data['data']['data']['id'] = data['id']
                    let payload = {
                        ...data['data'],
                        id: data['id'],
                        images: data['images'].map(obj => {
                            return {
                                ...obj,
                                status: this.mode == 'e' ? 'p' : null //if mode is edit then setting status equal to edit so that user can edit.
                            }
                        })
                    }
                    this.issue = payload
                }

                return 
            }

            let request_method = 'GET', url = this.$store.state.apiendpoints.data_issue + this.issue_id + "/"

            this.$vs.loading()

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.issue = res
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        async save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.data_issue

            if (this.issue.id && !this.use_cache) {
                request_method = 'PUT'
                url += this.issue.id + '/'
            }

            if (this.issue_type == 'road_user_accident') {
                this.update_road_user_accident_issue_time_details_data()
            }

            let payload = {
                ...this.issue,
                issue_type: this.issue_type,
                images: null
            }

            if (this.issue.images.length == 0 && this.issue.images.filter(v => typeof(v.image) != 'string').length == 0) {
                this.api_errors = {
                    "images": [
                        "Please select atleast 1 image",
                    ]
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Please fix the errors and try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
                return
            }

            this.submit_disabled = true

            if (!this.$store.state.is_online && request_method=='POST') {

                try {

                    let offline_data = {
                        status: 'pending',
                        data: payload,
                        images: this.issue.images,
                        timestamp: (new Date()).toISOString(),
                        sync_mode: 'offline'
                    }

                    let key = `issues__${this.issue_type}`
    
                    let res = await this.$ionicStorage.get(key)

                    // for saving payload when cache opens in edit mode.
                    if (this.issue.id) {
                        res = JSON.parse(res)

                        let payload = res.map(obj => {
                            if(obj.id == this.issue.id) {
                                offline_data['id']=this.issue.id
                                return offline_data
                            } else {
                                return obj
                            }
                        })

                        await this.$ionicStorage.set(key, JSON.stringify(payload))    

                    } else if(res) {
                        res = JSON.parse(res)
                        offline_data['id'] = res.length + 1
                        res.push(offline_data)
                        await this.$ionicStorage.set(key, JSON.stringify(res))
    
                    } else {
                        let arr = []
                        offline_data['id'] = 1
                        arr.push(offline_data)
                        await this.$ionicStorage.set(key, JSON.stringify(arr))
                    }

                    this.submit_disabled = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved in offline successfully.",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'cache-list', params: {issue_type: this.issue_type}})

                } catch (err) {
                    this.submit_disabled = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "Error occurred in saving offline!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })

                }

            } else if (!this.$store.state.is_online && request_method!='POST') {
                this.submit_disabled = false
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Entry is Rejected.",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            else {
                Request(this, request_method, url, null, payload).then(
                    async res => {
                        try {
    
                            await this.upload_images(res.id)
                            this.issue = {...res, images: this.issue.images}
    
                            this.submit_disabled = false
    
                            this.$vs.notify({
                                time: 3000,
                                title: 'Saved',
                                text: "Saved Successfully!",
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success'
                            })
                            this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})
                        } catch (e) {
                            this.submit_disabled = false
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "An erorr occurred while uploading images. Please try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        }
                    },
                    err => {
                        this.submit_disabled = false
                        if (err.error) {
                            this.api_errors = err.error
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "Please fix the errors and try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        } else {
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "An unknown error occurred! Please try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
    
                        }
                    }
                )
            }
        },
        async upload_images(issue_id) {
            for (let i=0; i < this.issue.images.length; i++) {
                this.$set(this.issue.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(issue_id, this.issue.images[i])
                    this.$set(this.issue.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.issue.images, i, data)
                } catch (e) {
                    this.$set(this.issue.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(issue_id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', 'p')

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_image, issue_id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )

            })
        },
        do_reject(data) {
            let payload = {
                action: 'reject',
                comment: data.comment
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.reject_popup.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.issue_id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false
                    this.reject_popup.active = false
                    this.reject_popup.api_errors = {}

                    this.init()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.reject_popup.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.reject_popup.active = false
                    }
                }
            )
        },
        approve() {
            this.$router.push({name: 'issues-approve', params: {
                issue_type: this.issue_type,
                issue_id: this.issue_id
            }})
        },
        reject () {
            this.reject_popup.active = true
        },
        update_road_user_accident_issue_time_details_data() {
            let keys = ['time_of_accident', 'accident_call_received_at', 'safety_team_reached_at', 'response_time', 'accident_clearance_time']

            keys.forEach((val) => {
                if (this.issue.data[val] == '') {
                    this.issue.data[val] = null
                }
            })
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__issue_${this.issue_type}`)
            permission.push(`review__assigned__issue_${this.issue_type}`)

            return permission.toString()
        }
    },
    components: {
        HighwayEdit,
        OccupationalEdit,
        HazardEdit,
        RoadUserAccidentEdit,
        TrafficViloationEdit,
        UnauthorisedAccessEdit,
        UnauthorisedMedianCutEdit,
        UnauthorisedParkingEdit,
        VehicleBreakdownEdit,
        MaterialDamageEdit,
        EnroachmentRowEdit,
        DeadAnimalDebrisRemovalEdit,
        OtherEdit,
        ElectricalMaintenanceEdit,
        MajorMaintenanceEdit,
        RoutineMaintenanceEdit,
        RejectionPopup }
}
</script>
